module.exports = __webpack_public_path__ + "img/19.9b362faa.jpg";